import { Component, ErrorHandler, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../shared/user.service';

@Component({
  selector: 'app-patientprofile-view',
  templateUrl: './patientprofile-view.component.html',
  styleUrls: ['./patientprofile-view.component.css']
})
export class PatientprofileViewComponent implements OnInit {
  hide:any;
  formInvalid : boolean = false;
  numericpattern:any;
  mode:any;
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,) 
 { }
p: any={};
  ngOnInit() {
  }

  // geturl()
  // {
  //   // r="/home/newpatient/newpatient-form"
  //   this.router.navigate(['/home/PatientView/PatientView1']);
  // }
}



// WEBPACK FOOTER //
// ./src/app/Pages/tasks/patientprofile-view/patientprofile-view.component.ts